import Picture from "@/components/common/picture/Picture";
import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { dehydrate, QueryClient, useQuery } from "@tanstack/react-query";
import { ApiResponseType, CategoryType, EntityType, ProductType } from "@/types";
import { getFilteredProductsApiCall, getProductsApiCall } from "@/api/Product";
import { getCategoriesApiCall } from "@/api/Category";
import { useForm } from "react-hook-form";
import SliderCard from "@/components/common/cards/SliderCard";
import BreadCrumbs from "@/components/common/ui/BreadCrumbs";
import Filter from "@/components/pages/category/Filter";

// interface Filters {
//   material: string | null;
//   collection: string | null;
//   additional: string | null;
//   color: string | null;
// }

export default function Category() {
  const [filterOpen, isFilterOpen] = useState(false);
  const [productCount, setProductCount] = useState<number>(9);

  const { register, watch, getValues } = useForm();
  const checkBoxValues = getValues();
  const filterValues = Object.values(checkBoxValues);
  // const filterKeys = Object.keys(checkBoxValues);

  // filterKeys.map((key) => {
  //   filterValues.map((value) => {
  //     if (key.includes("material") && value) {
  //       filter.material = value;
  //     }
  //   });
  // });

  const { data: productsData } = useQuery<ApiResponseType<ProductType>>({
    queryKey: ["getProductsApiCall"],
    queryFn: () => getProductsApiCall(),
  });

  const {
    data: categoriesData,
    error: categoriesError,
    isLoading: categoriesLoading,
  } = useQuery<ApiResponseType<CategoryType>>({
    queryKey: ["getCategoriesApiCall"],
    queryFn: getCategoriesApiCall,
  });

  const categoryProducts: Array<EntityType<ProductType>> = [];

  categoriesData?.data.map((data) => {
    data.attributes.products.data?.map((product) => {
      productsData?.data.map((productData) => {
        if (product.id === productData.id) {
          return categoryProducts.push(productData);
        }
      });
    });
  });

  // const ProductsPrice: Array<number> = [];
  // productsData?.data.map((item) => {
  //   return ProductsPrice.push(item.attributes.price);
  // });

  // const highestProductPrice = ProductsPrice.reduce((a, b) => Math.max(a, b));

  const ProductsPrice: Array<number> = [];
  productsData?.data.forEach((item) => {
    ProductsPrice.push(item.attributes.price);
  });

  const highestProductPrice =
    ProductsPrice.length > 0
      ? ProductsPrice.reduce((a, b) => Math.max(a, b), ProductsPrice[0])
      : 1000;

  const [price, setPrice] = useState({
    minPrice: 0,
    maxPrice: highestProductPrice > 0 ? highestProductPrice : 1000,
  });

  useEffect(() => {
    if (ProductsPrice.length > 0) {
      const highest = ProductsPrice.reduce((a, b) => Math.max(a, b), ProductsPrice[0]);
      setPrice({ minPrice: 0, maxPrice: highest });
    }
  }, [productsData]);

  const filter = {
    material: null,
    collection: null,
    additional: null,
    colors: {
      color_name: null,
    },
    price: { $gte: price.minPrice, $lte: price.maxPrice },
  };

  filterValues.map((value) => {
    if (value) {
      if (
        value === "metal" ||
        value === "plastic" ||
        value === "leather" ||
        value === "glass" ||
        value === "rattan"
      ) {
        return (filter.material = value);
      }
      if (
        value === "black" ||
        value === "brown" ||
        value === "light blue" ||
        value === "red" ||
        value === "dark green" ||
        value === "gray" ||
        value === "white"
      ) {
        return (filter.colors.color_name = value);
      }
      if (
        value === "minimalism" ||
        value === "eco style" ||
        value === "glam" ||
        value === "royal" ||
        value === "pink rose" ||
        value === "hi tech"
      ) {
        return (filter.collection = value);
      }
      if (
        value === "set" ||
        value === "combined" ||
        value === "transformer" ||
        value === "frameless"
      ) {
        return (filter.additional = value);
      }
    }
  });

  const { data: productsDataFiltered } = useQuery<ApiResponseType<ProductType>>({
    queryKey: ["getFilteredProductsApiCall", productCount, filter],
    queryFn: () =>
      getFilteredProductsApiCall({
        filters: filter,
        pagination: {
          pageSize: productCount,
        },
      }),
  });

  return (
    <main className="main-catalog lg:pt-10 pt-24 pb-[100px] bg-main-bg-color">
      <div className="container">
        <div className="catalog_wrapper flex flex-col">
          <BreadCrumbs category={"all products"} notCategory />

          <div className="catalog_title-wrapper lg:mt-[54px] mt-8">
            <h1 className="catalog_title lg:text-3xl text-2xl font-medium tracking-[3px] uppercase">
              all products
            </h1>
          </div>
          <div className="catalog_filter-sort-btns mt-6 flex items-center gap-4 xl:hidden">
            <button
              onClick={() => isFilterOpen(!filterOpen)}
              className="catalog_filter-btn flex items-center justify-center bg-disable-color w-[162px] h-[46px] gap-[10px]"
            >
              <p className="catalog_filter-title tracking-[2px] text-white uppercase">Filters</p>
              {/* <p className="catalog_filter-number tracking-[2px] text-white">4</p>
              <Picture
                src={"/icons/Icon name=close - white.svg"}
                alt={"close"}
                width={20}
                height={20}
              /> */}
            </button>
            {/* <button className="catalog_sort-btn flex items-center justify-center bg-white w-[162px] h-[46px] gap-[10px] border border-disable-color">
              <p className="catalog_filter-title tracking-[2px] text-secondary-text-color uppercase">
                Sort
              </p>
              <p className="catalog_filter-number tracking-[2px] text-secondary-text-color">1</p>
              <Picture src={"/icons/Icon name=close.svg"} alt={"close"} width={20} height={20} />
            </button> */}
          </div>
          {/* <div className="catalog_filter-sort-tags mt-[30px] flex flex-row items-center gap-[10px] flex-wrap">
            <div className="catalog_sort-tag_wrapper flex items-center justify-center gap-[6px] bg-white w-fit py-1 px-[14px] border border-disable-text-color cursor-pointer">
              <p className="catalog_sort-tag-title font-medium text-disable-color">Price: </p>
              <p className="catalog_sort-tag-desc uppercase font-medium text-sm leading-6 tracking-[1px] align-middle">
                low to high
              </p>
            </div>
            <div className="catalog_sort-tag_wrapper flex items-center justify-center gap-[6px] bg-white w-fit py-1 px-[14px] border border-disable-text-color cursor-pointer">
              <p className="catalog_sort-tag-title font-medium text-disable-color">Price: </p>
              <p className="catalog_sort-tag-desc uppercase font-medium text-sm leading-6 tracking-[1px] align-middle">
                high to low
              </p>
            </div>
            <div className="catalog_sort-tag_wrapper flex items-center justify-center gap-[6px] bg-white w-fit py-1 px-[14px] border border-disable-text-color cursor-pointer text-secondary-text-color selected-sort">
              <p className="catalog_sort-tag-desc uppercase font-medium text-sm leading-6 tracking-[1px] align-middle">
                Bestselling
              </p>
            </div>
            <div className="catalog_sort-tag_wrapper flex items-center justify-center gap-[6px] bg-white w-fit py-1 px-[14px] border border-disable-text-color cursor-pointer text-secondary-text-color">
              <p className="catalog_sort-tag-desc uppercase font-medium text-sm leading-6 tracking-[1px] align-middle">
                Relevance
              </p>
            </div>
            <div className="catalog_filter-sort-tags_divider w-[2px] h-[32px] bg-disable-color max-w-[2px]"></div>
            <div className="catalog_filter-tag_wrapper flex items-center justify-center gap-[6px] bg-white w-fit py-1 px-[14px] border border-disable-text-color cursor-pointer">
              <p className="catalog_filter-tag-title font-medium text-disable-color">Color: </p>
              <p className="catalog_filter-tag-desc uppercase font-medium text-sm leading-6 tracking-[1px] align-middle">
                Black
              </p>
              <Picture src={"/icons/Icon name=close.svg"} alt={"close"} width={16} height={16} />
            </div>
            <div className="catalog_filter-tag_wrapper flex items-center justify-center gap-[6px] bg-white w-fit py-1 px-[14px] border border-disable-text-color cursor-pointer">
              <p className="catalog_filter-tag-title font-medium text-disable-color">Material:</p>
              <p className="catalog_filter-tag-desc uppercase font-medium text-sm leading-6 tracking-[1px] align-middle">
                Leather
              </p>
              <Picture src={"/icons/Icon name=close.svg"} alt={"close"} width={16} height={16} />
            </div>
            <div className="catalog_filter-tag_wrapper flex items-center justify-center gap-[6px] bg-white w-fit py-1 px-[14px] border border-disable-text-color cursor-pointer">
              <p className="catalog_filter-tag-title font-medium text-disable-color">Collection:</p>
              <p className="catalog_filter-tag-desc uppercase font-medium text-sm leading-6 tracking-[1px] align-middle">
                Minimalism
              </p>
              <Picture src={"/icons/Icon name=close.svg"} alt={"close"} width={16} height={16} />
            </div>
            <button className="catalog_filter-tags_clear-btn flex items-center justify-center w-fit py-1 px-[14px] uppercase border border-accent-color bg-accent-color text-white font-medium tracking-[1px] text-sm leading-6">
              clear all
            </button>
          </div> */}
          <div className="catalog_main-wrapper mt-10 flex gap-8 relative">
            <div className="catalog_products-wrapper flex flex-col items-center w-full">
              <div className="catalog_products-inner-wrapper flex items-center gap-6 flex-wrap md:justify-start justify-center">
                {productsDataFiltered?.data &&
                  productsDataFiltered.data.map((productData, index) => {
                    return <SliderCard data={productData} key={index} />;
                  })}
              </div>

              <div className="catalog_product-divider w-full h-[1px] bg-disable-color my-10"></div>
              <button
                onClick={() => setProductCount((prevState) => prevState + 9)}
                type="button"
                className="catalog_product_show-btn w-[214px] h-[60px] flex items-center justify-center bg-disable-color gap-[14px]"
              >
                <p className="catalog_product_show-btn_title uppercase text-white tracking-[2px]">
                  show more
                </p>
                <Picture
                  src={"/icons/Icon name=down arrow - white.svg"}
                  alt={"down arrow"}
                  width={24}
                  height={24}
                />
              </button>
            </div>

            <Filter
              filterOpen={filterOpen}
              highestProductPrice={highestProductPrice}
              price={price}
              setPrice={setPrice}
              watch={watch}
              getValues={getValues}
              register={register}
            />
          </div>
        </div>
      </div>
    </main>
  );
}

export async function getServerSideProps() {
  const queryClient = new QueryClient();

  await queryClient.prefetchQuery({
    queryKey: [getProductsApiCall.name],
    queryFn: getProductsApiCall,
  });

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
}
